/** @jsxImportSource @emotion/react */
import { Button, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

/**
 * Fundamental component for confirmation buttons on any confirmation dialog.
 * Typically Yes/No buttons, some other instances as well.
 *
 * @param {*} props - see propTypes below for more details
 * @returns
 */
const ConfirmButton = (props) => {
  return (
    <Button
      className={props.className}
      variant={props.variant}
      color={props.color}
      onClick={props.onClick}
      disabled={props.isLoading || props.disabled}
      size="large"
      sx={{
        margin: "5px",
        minWidth: "100px",
      }}
    >
      {props.isLoading && props.children !== "No" ? <CircularProgress size={24} /> : props.children}
    </Button>
  );
};

ConfirmButton.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default ConfirmButton;
